// Las jornadas de un torneo INTERNO, como las recorre la pestana Rol.
//
// Antes la pestana pintaba TODO el torneo: cada fecha con sus tarjetas, una debajo de
// otra. Con 15 jornadas de 10 juegos eso son 150 tarjetas para encontrar la del sabado
// (el dueno, 2026-09-09). Aqui el torneo se parte en jornadas y la pantalla muestra UNA,
// la que toca hoy, con flechas para ir a la anterior y la siguiente.
//
// La jornada es el DIA. `juegos.jornada` existe pero es opcional y el club no siempre la
// captura; la fecha siempre esta, y es la unidad que se comparte como imagen (un rol por
// dia). Cuando todos los juegos del dia traen el mismo numero de jornada, se nombra.

import { agruparJuegosPorFecha } from './juegosPorFecha'
import { tituloDelRolInterno } from './rolInterno'
import { getMexicoDateString } from './dateUtils'

export const SIN_FECHA = 'sin-fecha'

const hhmm = (h) => (h ? String(h).slice(0, 5) : null)

const numeroCampo = (juego) => {
  const crudo = juego?.campo_numero
  if (crudo === null || crudo === undefined || String(crudo).trim() === '') return null
  const n = Number(crudo)
  return Number.isFinite(n) ? n : null
}

const grupoDe = (juego) =>
  juego?.grupo?.nombre_del_grupo || juego?.grupos?.nombre_del_grupo || ''

// Primero la hora, luego el campo, luego el grupo. Los juegos sin hora al final del dia
// y los sin campo al final de su hora: no se puede afirmar que vayan antes.
export const ordenarJuegosDeJornada = (juegos = []) =>
  [...(juegos || [])].filter(Boolean).sort((a, b) => {
    const h = (hhmm(a.hora) || '99:99').localeCompare(hhmm(b.hora) || '99:99')
    if (h !== 0) return h
    const ca = numeroCampo(a)
    const cb = numeroCampo(b)
    if (ca !== cb) {
      if (ca === null) return 1
      if (cb === null) return -1
      return ca - cb
    }
    return grupoDe(a).localeCompare(grupoDe(b))
  })

// Los juegos de una jornada en bloques por hora, en el orden de arriba: el mismo grupo
// puede jugar a las 9:00 y a las 11:00 y cada hora es un renglon del rol.
export const bloquesPorHora = (juegos = []) => {
  const bloques = []
  ordenarJuegosDeJornada(juegos).forEach((j) => {
    const hora = hhmm(j.hora)
    const ultimo = bloques[bloques.length - 1]
    if (ultimo && ultimo.hora === hora) ultimo.juegos.push(j)
    else bloques.push({ hora, juegos: [j] })
  })
  return bloques
}

const capitalizar = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1) : s)

// [{ key, fecha, label, jornada, titulo, juegos }], la fecha mas cercana primero y los
// juegos sin fecha al final, como la agenda. `jornada` es "Jornada 3" cuando todo el dia
// la comparte, o '' si no; `titulo` es lo que se lee en el selector.
export const jornadasDeTorneo = (juegos = []) =>
  agruparJuegosPorFecha(juegos).map((g) => {
    const jornada = tituloDelRolInterno(g.juegos)
    const label = g.fecha === SIN_FECHA ? 'Sin fecha' : capitalizar(g.label)
    return {
      key: g.fecha,
      fecha: g.fecha === SIN_FECHA ? null : g.fecha,
      label,
      jornada,
      titulo: jornada ? `${jornada} · ${label}` : label,
      juegos: ordenarJuegosDeJornada(g.juegos),
    }
  })

// La jornada que se abre por defecto: la de hoy o la proxima. Si el torneo ya paso, la
// ultima que se jugo; si nada tiene fecha, la primera que haya.
export const jornadaActual = (jornadas = [], hoy = getMexicoDateString()) => {
  const lista = jornadas || []
  if (lista.length === 0) return -1
  const proxima = lista.findIndex((j) => j.fecha && j.fecha >= hoy)
  if (proxima >= 0) return proxima
  let ultimaConFecha = -1
  lista.forEach((j, i) => { if (j.fecha) ultimaConFecha = i })
  return ultimaConFecha >= 0 ? ultimaConFecha : 0
}
